import axios from 'src/utils/axios';
import type { Event, EvtTicketProcessCreateByDU } from 'src/models/event';
import type { Statistic, StatisticsDetail, BoleteriaStatsResponse } from 'src/models/statistic';
import {
  startLoadingEvents,
  setEvents,
  setEventsPaginated,
  setError,
  setChangeEvent,
  startLoadingEventsStatistics,
  setEventsStatistics,
  setEventsStatisticsPaginated,
  setErrorEventsStatistics,
  startLoadingReferencedRrpp,
  setEventsStatisticsDetailPaginated,
  setErrorReferencedRrpp,
  setReferencedRrpp,
  startLoadingStatisticsByProducer,
  setStatisticsByProducer,
  setStatisticsByProducerPaginated,
  setErrorStatisticsByProducer,
  startLoadingDirectRrpp,
  setStatisticsDirectRrpp,
  setDirectRrppPaginated,
  setErrorDirectRrpp,
  startLoadingLoyalty,
  setExchangesLoyalty,
  setErrorLoyalty,
  startLoadingStatisticsGift,
  setErrorStatisticsGift,
  setStatisticsGift,
  stopLoadingEvent,
  setChangeEvtTktProcess,
  startLoadingEvtTktProcessByDU,
  stopLoadingEvtTktProcessByDU,
  stopLoadingStatisticsByProducer,
  stopLoadingReferencedRrpp,
  stopLoadingLoyalty,
  stopLoadingStatisticsGift,
  stopLoadingDirectRrpp,
  stopLoadingEventsStatistics,
  setErrorBoleteria,
  startLoadingBoleteria,
  stopLoadingBoleteria,
  setStatisticsBoleteria,
  startLoadingSalesHistory,
  stopLoadingSalesHistory,
  setSalesHistory,
  setSalesHistoryError,
  startLoadingSaleDetail,
  setSaleDetail,
  setSaleDetailError,
  startSendingResendEmail,
  setResendEmailSuccess,
  setResendEmailError,
  startSendingResendWhatsapp,
  setResendWhatsappSuccess,
  setResendWhatsappError,
  startLoadingPrintTickets,
  setPrintTickets,
  setPrintTicketsError,
} from './eventSlice';
import { AppDispatch } from 'src/store';
import axiosInst from 'src/utils/axiosCreate';
import getFirebaseQPDownloadUrl from 'src/utils/firebaseDownloadXlsx';

export const getAllEvents = (isSelling: boolean) => {
  return async (dispatch: AppDispatch) => {
    dispatch(startLoadingEvents());
    try {
      const params = {
        isSelling: isSelling
      };
      const response = await axiosInst.get<{ data: Event[] }>('/events?', { params });
      dispatch(setEvents(response.data.data));

    } catch (error) {
      const resp = error.response;
      dispatch(setError({ status: resp.status, message: resp.data.message }));
    } finally {
      dispatch(stopLoadingEvent());
    }
  };
};

export const getFilteredEvents = (filters: any) => {
  return async (dispatch: AppDispatch, getState) => {
    dispatch(startLoadingEvents());
    try {
      const state = getState();
      const { isMultiproducer, selectedProducer } = state.auth;
      
      let filtersToSend = { ...filters };
      
      if (isMultiproducer && selectedProducer && selectedProducer.id) {
        const producerId = parseInt(selectedProducer.id, 10);
        if (!isNaN(producerId)) {
          filtersToSend.evtIdProducers = [producerId];
        }
      }
      
      const response = await axiosInst.post(`/events/filters`, filtersToSend);    
      dispatch(
        setEventsPaginated({
          events: response.data.data.events,
          totalEvents: parseInt(response.data.data.totalEvents, 10),
          currentPage: response.data.data.currentPage,
          totalPages: response.data.data.totalPages
        })
      );
    } catch (error) {
      const resp = error.response;
      dispatch(setError({ status: resp.status, message: resp.data.message }));
      dispatch(stopLoadingEvent());
      
    } finally {
      dispatch(stopLoadingEvent());
    }
  };
};

interface EventDTO {
  event: any;
  userId: string;
  isCopyWithTickets?: boolean;
}

// add nuevo funcionando - para create y copy
export const addEvent = (event, evtCreateUser, isCopyWithTickets?: boolean, copyEvent?: boolean) => {
  return async (dispatch: AppDispatch, getState) => {
    try {
      dispatch(startLoadingEvents());

      const state = getState();
      const { isMultiproducer, selectedProducer } = state.auth;
      
      let producerId = undefined;
      if (isMultiproducer && selectedProducer && selectedProducer.id) {
        const parsedId = parseInt(selectedProducer.id, 10);
        if (!isNaN(parsedId)) {
          producerId = parsedId;
        }
      }

      let eventToSend = { ...event };

      if (copyEvent) {
        delete eventToSend.evtCreated;
        delete eventToSend.evtLastUpdate;
        delete eventToSend.evtLastUpdateUser;
        delete eventToSend.evtCoordinates;
        delete eventToSend.evtPlaceAddress;
        delete eventToSend.evtPlace;
        delete eventToSend.evtCreateUser;
        delete eventToSend.evtProducer;
        
        if (producerId !== undefined) {
          eventToSend.evtIdProducer = producerId;
        }
        
        const copyPayload: any = { event: eventToSend, isCopyWithTickets };
    
        const resp = await axiosInst.post(`/events/copy`, copyPayload);

        dispatch(setChangeEvent(resp.data.data));
        dispatch(setError({ status: resp.status, message: resp.statusText }));
        
        return; 
      }

      if (producerId !== undefined) {
        eventToSend.evtIdProducer = producerId;
      }

      const eventDTO: any = {
        event: eventToSend,
        userId: evtCreateUser,
      };

      const resp = await axiosInst.post(`/events/create`, eventDTO);

      dispatch(setChangeEvent(resp.data.data));
      dispatch(setError({ status: resp.status, message: resp.statusText }));
     
    } catch (error) {
      const resp = error.response;
     
      dispatch(setError({ status: resp.status, message: resp.data.message }));
      throw error;
    }
    finally{
      dispatch(stopLoadingEvent());
    }
  };
};

// update nuevo funcionando

export const eventUpdate = (event, evtCreateUser) => {
  return async (dispatch: AppDispatch, getState) => {
    try {
      const state = getState();
      const { isMultiproducer, selectedProducer } = state.auth;

      let eventToUpdate = { ...event };

      if (isMultiproducer && selectedProducer && selectedProducer.id) {
        const producerId = parseInt(selectedProducer.id, 10);
        if (!isNaN(producerId)) {
          eventToUpdate.evtIdProducer = producerId;
        }
      }

      const eventDTO: EventDTO = {
        event: eventToUpdate,
        userId: evtCreateUser
      };

      const resp = await axiosInst.put(`/events/update`, eventDTO);

      dispatch(setChangeEvent({ ...eventToUpdate }));
      dispatch(setError({ status: resp.status, message: resp.data?.message ?? resp.statusText }));

      return resp;
    } catch (error: any) {
      const resp = error?.response;
      const isTimeout = error?.code === 'ECONNABORTED';

      dispatch(
        setError({
          status: resp?.status ?? (isTimeout ? 408 : 500),
          message:
            resp?.data?.message ||
            (isTimeout ? 'Request timeout' : error?.message || 'Unknown error')
        })
      );
      throw error;
    }
  };
}; 

// update nuevo funcionando

export const  activateOrDeactivateEvent = (event) => {
  return async (dispatch: AppDispatch) => {
    try {
      dispatch(startLoadingEvents());
      const resp = await axiosInst.put(`/events/status-change`, event);
      dispatch(setChangeEvent(resp.data));
      dispatch(setError({ status: resp.status, message: resp.statusText }));
      dispatch(stopLoadingEvent());
    } catch (error) {
      const resp = error.response;
      dispatch(stopLoadingEvent());
      dispatch(setError({ status: resp.status, message: resp.data.message }));
      throw error;
    }
  };
}; 

//delete nuevo funcionando
export const deleteEvent = (event: Event, userId: string) => {
  return async (dispatch: AppDispatch, getState) => {
    try {
      dispatch(startLoadingEvents());
      
      const state = getState();
      const { isMultiproducer, selectedProducer } = state.auth;
      
      const eventData: any = {
        evtTitle: event.evtTitle,
        evtName: event.evtName,
        evtDescription: event.evtDescription,
        evtDateTime: event.evtDateTime.toLocaleString(),
        evtInitDate: event.evtInitDate.toLocaleString(),
        evtEndDate: event.evtEndDate.toLocaleString(),
        evtPlaceId: event.evtPlaceId,
        evtImgPath: event.evtImgPath ? event.evtImgPath : '',
        evtState: event.evtState,
        id: event.id,
        userId: userId
      };
      
      if (isMultiproducer && selectedProducer && selectedProducer.id) {
        const producerId = parseInt(selectedProducer.id, 10);
        if (!isNaN(producerId)) {
          eventData.evtIdProducer = producerId;
        }
      }
      
      const resp = await axiosInst.delete(`/events/deleted`, {
        data: eventData
      });
      dispatch(setChangeEvent(resp.data.events));
      dispatch(setError({ status: resp.status, message: resp.statusText }));
    } catch (error) {
      const resp = error.response;
      dispatch(setError({ status: resp.status, message: resp.data.message }));
      throw error;
    }
  };
};

export const deleteTagFromEvent = (eventId: any, tagId: string) => {
  return async (dispatch: AppDispatch) => {
    try {
      dispatch(startLoadingEvents());
      const resp = await axios.delete(`/api/events/tags`, {
        params: { eventId, tagId }
      });
      dispatch(setChangeEvent({ eventId, tagId }));
      dispatch(setError({ status: resp.status, message: resp.statusText }));
    } catch (error) {
      console.log(error);
      const resp = error.response;
      dispatch(setError({ status: resp.status, message: resp.data.message }));
    }
  };
};

export const downloadEvents = async (exportDTO) => {
  try {
    const resp = await axiosInst.post(`/events/export`, exportDTO);
    const filename: string = resp.data.data.filename;
    const url: any = await getFirebaseQPDownloadUrl(filename);

    setTimeout(function () {
      window.open(url, '_self');
    }, 200);

  } catch (error) {
    const resp = error;
    throw error;
  }
};

export const downloadStatisticsGift = async (exportDTO: { eventId: string; search?: string; evtName?: string }) => {
  try {
    const resp = await axiosInst.post(`/events/detail-gift/export`, exportDTO);
    const filename: string = resp.data.data.filename;
    const url: any = await getFirebaseQPDownloadUrl(filename);

    setTimeout(function () {
      window.open(url, '_self');
    }, 200);

  } catch (error) {
    throw error;
  }
};

export const deleteAllTagsFromEvents = (tagId: string) => {
  return async (dispatch: AppDispatch) => {
    try {
      dispatch(startLoadingEvents());
      const resp = await axios.delete(`/api/events/tags/all`, {
        params: { tagId }
      });
      dispatch(setChangeEvent({ tagId }));
      dispatch(setError({ status: resp.status, message: resp.statusText }));
    } catch (error) {
      console.log(error);
      const resp = error.response;
      dispatch(setError({ status: resp.status, message: resp.data.message }));
    }
  };
};

//Statistics List
export const getAllEventsStatistics = (eventId: string) => {
  return async (dispatch:AppDispatch) => {
    dispatch(startLoadingEventsStatistics());
    try {
      const response = await axiosInst.post<{ eventsStatistics: Statistic[] }>(
        '/events/statistics', { eventId: eventId }
      );
      dispatch(setEventsStatistics(response.data));
      dispatch(setErrorEventsStatistics({
          status: response.status,
          message: response.statusText
        })
      );
    } catch (error) {
      const resp = error.response;
      dispatch(setErrorEventsStatistics({ status: resp.status, message: resp.data.message }));
    } finally {
      dispatch(stopLoadingEventsStatistics());
    }
  };
};

export const getWithParamsEvtStatistics = (page = 1) => {
  return async (dispatch) => {
    try {
      dispatch(startLoadingEventsStatistics);
      const resp = await axios.get(
        `/api/events/statistics/list?limit=${25}&page=${page}`
      );
      const { data } = resp;
      dispatch(setEventsStatisticsPaginated({ events: data, page }));
      dispatch(
        setErrorEventsStatistics({
          status: resp.status,
          message: resp.statusText
        })
      );
    } catch (error) {
      console.log(error);
    }
  };
};

//Detail Referenced-rrpp
export const getAllReferencedRrpp = (eventId: string) => {
  return async (dispatch: AppDispatch) => {
    dispatch(startLoadingReferencedRrpp());
    try {
      const response = await axiosInst.post<{ statisticsDetail }>(
        '/events/detail-referenced-rrpp', { eventId: eventId }
      );
      dispatch(setReferencedRrpp(response.data));
      dispatch(setErrorReferencedRrpp({
                  status: response.status,
                  message: response.statusText
                })
              );
    } catch (error) {
      const resp = error.response;
      dispatch(setErrorReferencedRrpp({ status: resp.status, message: resp.data.message }));
    } finally {
      dispatch(stopLoadingReferencedRrpp());
    }
  };
};

export const getWithParamsStsDetail = (page = 1) => {
  return async (dispatch) => {
    try {
      const resp = await axios.get(
        `/api/events/statistics/list/referenced-rrpp?limit=${25}&page=${page}`
      );
      const { data } = resp;
      dispatch(setEventsStatisticsDetailPaginated({ events: data, page }));
      dispatch(
        setErrorReferencedRrpp({
          status: resp.status,
          message: resp.statusText
        })
      );
    } catch (error) {
      console.log(error);
    }
  };
};

//Detail sells by Producer
export const getAllStatisticsByProducer = (eventId : string) => {
  return async (dispatch: AppDispatch) => {
    dispatch(startLoadingStatisticsByProducer());
    try {
      const response = await axiosInst.post<{ statisticsByProducer }>(
        '/events/detail-producer', { eventId: eventId }
      );
      dispatch(setStatisticsByProducer(response.data));
      dispatch(setErrorStatisticsByProducer({
        status: response.status,
        message: response.statusText
      })
    );
    } catch (error) {
      const resp = error.response;
      dispatch(setErrorStatisticsByProducer({ status: resp.status, message: resp.data.message }));
    } finally {
      dispatch(stopLoadingStatisticsByProducer());
    }
  };
};

export const getWithParamsStsByProducer = (page = 1) => {
  return async (dispatch) => {
    try {
      dispatch(startLoadingStatisticsByProducer);
      const resp = await axios.get(
        `/api/events/statistics/producer?limit=${25}&page=${page}`
      );
      const { data } = resp;
      dispatch(setStatisticsByProducerPaginated({ events: data, page }));
      dispatch(
        setErrorStatisticsByProducer({
          status: resp.status,
          message: resp.statusText
        })
      );
    } catch (error) {
      console.log(error);
    }
  };
};

//DirectRRPP
export const getAllStatisticsDirectRrpp = (eventId: string) => {
  return async (dispatch: AppDispatch) => {
    dispatch(startLoadingDirectRrpp());
    try {
      const response = await axiosInst.post<{ statisticsDirectRrpp: StatisticsDetail[]; }>(
        '/events/detail-direct-rrpp', { eventId: eventId });
      dispatch(setStatisticsDirectRrpp(response.data));
      dispatch(setErrorDirectRrpp({
          status: response.status,
          message: response.statusText
        })
      );
    } catch (error) {
      const resp = error.response;
      dispatch(setErrorDirectRrpp({ status: resp.status, message: resp.data.message }));

    } finally{
      dispatch(stopLoadingDirectRrpp());
    }
  };
};

export const getWithParamsStsDirectRrpp = (page = 1) => {
  return async (dispatch) => {
    try {
      dispatch(startLoadingDirectRrpp);
      const resp = await axios.get(
        `/api/events/statistics/direct-rrpp?limit=${25}&page=${page}`
      );
      const { data } = resp;
      dispatch(setDirectRrppPaginated({ events: data, page }));
      dispatch(
        setErrorDirectRrpp({ status: resp.status, message: resp.statusText })
      );
    } catch (error) {
      console.log(error);
    }
  };
};

//Loyalty
export const getAllExchangesLoyalty = (eventId: string) => {
  return async (dispatch: AppDispatch) => {
    dispatch(startLoadingLoyalty());
    try {
      const response = await axiosInst.post<{
        exchangesLoyalty: StatisticsDetail[];
      }>('/events/detail-loyalty', { eventId });
      dispatch(setExchangesLoyalty(response.data));
      dispatch(setErrorLoyalty({
        status: response.status,
        message: response.statusText
      })
    );
    } catch (error) {
      const resp = error.response;
      dispatch(setErrorLoyalty({ status: resp.status, message: resp.data.message }));
    } finally {
      dispatch(stopLoadingLoyalty());
    }
  };
};

export const getWithParamsLoyalty = (page = 1) => {
  return async (dispatch) => {
    try {
      dispatch(startLoadingLoyalty);
      const resp = await axios.get(
        `/api/events/statistics/loyalty?limit=${25}&page=${page}`
      );
      const { data } = resp;
      dispatch(setExchangesLoyalty({ events: data, page }));
      dispatch(
        setErrorLoyalty({ status: resp.status, message: resp.statusText })
      );
    } catch (error) {
      console.log(error);
    }
  };
};

//Detail Gift
export const getAllStatisticsGift = (eventId: string) => {
  return async (dispatch: AppDispatch) => {
    dispatch(startLoadingStatisticsGift());
    try {
      const response = await axiosInst.post<{ statisticsGift: StatisticsDetail[] }>(
        '/events/detail-gift', { eventId: eventId }
      );
      dispatch(setStatisticsGift(response.data));
      dispatch(setErrorStatisticsGift({
        status: response.status,
        message: response.statusText
      })
    );
    } catch (error) {
      const resp = error.response;
      dispatch(setErrorStatisticsGift({ status: resp.status, message: resp.data.message }));
    } finally {
      dispatch(stopLoadingStatisticsGift());
    }
  };
};

export const getWithParamsStatisticsGift = (page = 1) => {
  return async (dispatch) => {
    try {
      dispatch(startLoadingStatisticsGift);
      const resp = await axios.get(
        `/api/events/statistics/gitf?limit=${25}&page=${page}`
      );
      const { data } = resp;
      dispatch(setStatisticsGift({ events: data, page }));
      dispatch(
        setErrorStatisticsGift({
          status: resp.status,
          message: resp.statusText
        })
      );
    } catch (error) {
      console.log(error);
    }
  };
};

export const ticketProcessCreateByDU = (TicketCreateByDUDTO) => {
  return async (dispatch: AppDispatch) => {
    try {
      dispatch(startLoadingEvtTktProcessByDU());
      const bodyDTO: EvtTicketProcessCreateByDU = {
        eventId: TicketCreateByDUDTO.eventId,
        user: TicketCreateByDUDTO.user,
        shouldRegister: TicketCreateByDUDTO.shouldRegister,
        ticketTypes: TicketCreateByDUDTO.ticketTypes,
        paymentMethod: TicketCreateByDUDTO.paymentMethod,
        origin: "boleteria"
      };

      const resp = await axiosInst.post(`/events/ticketsProcess/createByDU`, bodyDTO);

      if (resp.data && resp.data.data) {
        dispatch(setChangeEvtTktProcess(resp.data.data));
        dispatch(setError({ status: resp.status, message: resp.statusText }));
        return { success: true, data: resp.data.data };
      } else {
        throw new Error("Response data format is not correct");
      }

    } catch (error) {
      const errorMessage = error.response
        ? error.response.data.message || error.response.statusText
        : error.message || "An unknown error occurred";

      dispatch(setError({ status: error.response?.status || 500, message: errorMessage }));
      return { success: false, error: errorMessage };
    } finally {
      dispatch(stopLoadingEvtTktProcessByDU());
    }
  };
};

//Boleteria
export const getAllStatisticsBoleteria = (eventId: string, from?: number, to?: number, search?: string) => {
  return async (dispatch: AppDispatch) => {
    dispatch(startLoadingBoleteria());
    try {
      const body: { eventId: string; from?: number; to?: number; search?: string } = { eventId };
      if (from !== undefined) body.from = from;
      if (to !== undefined) body.to = to;
      if (search !== undefined && search.trim() !== '') body.search = search.trim();

      const response = await axiosInst.post<{ data: BoleteriaStatsResponse }>(
        '/events/detail-boleteria', body
      );
      dispatch(setStatisticsBoleteria({ data: response.data.data }));
      dispatch(setErrorBoleteria({
        status: response.status,
        message: response.statusText
      }));
    } catch (error) {
      const resp = error.response;
      dispatch(setErrorBoleteria({ status: resp?.status || 500, message: resp?.data?.message || 'Error desconocido' }));
    } finally {
      dispatch(stopLoadingBoleteria());
    }
  };
};

export const getBoleteriaSalesHistory =
  (
    eventId: string,
    params: {
      page: number;
      limit: number;
      sortBy?: 'created_date' | 'paymentMethod' | 'status' | 'buyerName';
      sortOrder?: 'asc' | 'desc';
      operationId?: string | null;
      fechaDesde?: string | null;
      fechaHasta?: string | null;
      buyerQuery?: string | null;
      paymentMethod?: string | null;
      status?: string | null;
      signal?: AbortSignal;
    }
  ) =>
  async (dispatch) => {
    try {
      dispatch(startLoadingSalesHistory());

      const { page, limit, sortBy, sortOrder, operationId, fechaDesde, fechaHasta, buyerQuery, paymentMethod, status, signal } = params;

      const paramsToSend: Record<string, string | number | boolean> = {
        page,
        limit,
        includeTotal: true
      };

      if (sortBy) {
        paramsToSend.sortBy = sortBy;
        paramsToSend.sortOrder = sortOrder ?? 'desc';
      }

      if (operationId?.trim()) paramsToSend.operationId = operationId.trim();
      if (fechaDesde?.trim()) paramsToSend.fechaDesde = fechaDesde.trim();
      if (fechaHasta?.trim()) paramsToSend.fechaHasta = fechaHasta.trim();
      if (buyerQuery?.trim()) paramsToSend.buyerQuery = buyerQuery.trim();
      if (paymentMethod?.trim()) paramsToSend.paymentMethod = paymentMethod.trim();
      if (status?.trim()) paramsToSend.status = status.trim();

      const response = await axiosInst.get(`/events/${eventId}/sales`, {
        params: paramsToSend,
        signal
      });

      dispatch(
        setSalesHistory({
          items: response?.data?.data?.items ?? [],
          totalItems: response?.data?.data?.totalItems ?? 0
        })
      );
    } catch (error: any) {
      const isCanceled = error?.name === 'CanceledError' || error?.code === 'ERR_CANCELED';
      if (!isCanceled) {
        dispatch(setSalesHistoryError(error?.message || 'There is an error!'));
      }
    } finally {
      dispatch(stopLoadingSalesHistory());
    }
  };

  export const getBoleteriaSaleDetail =
    (operationId: string) => async (dispatch) => {
      try {
        dispatch(startLoadingSaleDetail());

        const response = await axiosInst.get(`/events/sales/${operationId}`);

        dispatch(
          setSaleDetail({
            detail: response?.data?.data ?? null
          })
        );
      } catch (error: any) {
        dispatch(setSaleDetailError(error?.message || 'There is an error!'));
      }
    };
  
  export const resendTicketsEmail =
    (operationId: string, email: string) => async (dispatch: any) => {
      try {
        dispatch(startSendingResendEmail());
        const resp = await axiosInst.post('/payments/resend-tickets-email', {
          operationId,
          email
        });
        dispatch(setResendEmailSuccess());
      } catch (error: any) {
        dispatch(setResendEmailError(error?.message || 'There is an error!'));
      }
    };

  export const resendTicketsWhatsapp =
    (operationId: string, phone: string, countryCode?: string) => async (dispatch: any) => {
      try {
        dispatch(startSendingResendWhatsapp());
        const body: any = { operationId, phone };
        if (countryCode) body.countryCode = countryCode;
        const resp = await axiosInst.post(
          '/payments/resend-tickets-whatsapp',
          body
        );
        dispatch(setResendWhatsappSuccess());
      } catch (error: any) {
        dispatch(setResendWhatsappError(error?.message || 'There is an error!'));
      }
    };

export type ValidatePlaceChangeResponse = {
  canChange: boolean;
  blockType?: 'reversible' | 'permanent';
};

/** Si se envía placeId, el backend obtiene los sectores desde MySQL (tabla SECTORS). Solo llama al BE si plcHasSectors es true. */
export const validatePlaceChange = async (
  eventId: string,
  placeId?: string,
  plcHasSectors?: boolean
): Promise<ValidatePlaceChangeResponse> => {
  if (plcHasSectors !== true) {
    return { canChange: true };
  }
  try {
    const res = await axiosInst.post<{ data: ValidatePlaceChangeResponse; message?: string }>(
      '/events/validate-place-change',
      { eventId, ...(placeId ? { placeId } : {}) }
    );
    const body = res.data as { data?: ValidatePlaceChangeResponse } | ValidatePlaceChangeResponse;
    return body && 'data' in body && body.data ? body.data : (body as ValidatePlaceChangeResponse);
  } catch (error) {
    throw error;
  }
};

export const getTicketsByOperationIdForPrint =
  (operationId: string) => async (dispatch: any) => {
    try {
      dispatch(startLoadingPrintTickets());

      const response = await axiosInst.post('/payments/tickets', {
        operationId,
      });

      const tickets = response?.data?.data?.tickets ?? [];
      const general = response?.data?.data?.general ?? null;

      dispatch(
        setPrintTickets({
          operationId,
          tickets,
          general,
        }),
      );
    } catch (error: any) {
      const msg =
        error?.response?.data?.message ||
        error?.message ||
        'Error al obtener tickets para imprimir';
      dispatch(setPrintTicketsError(msg));
    }
  };